import { clientBase } from "../common";

export const getItems = (_perPage, _currentPage) => {
  return clientBase(`v2/getRelatedCourses/${process.env.VUE_APP_PROYECT_ID}/${_perPage}?page=${_currentPage}`, "GET");
};
